<template>
    <div style=" flex: 1; overflow-y: scroll; overflow-x: hidden; background: radial-gradient(216.41% 100% at 50% 100%, #FFFFFF 0%, #FFF4EC 44.01%, #FFD5C0 56.72%, #FFE0BA 84.59%, #FFAF79 100%); display: flex; flex-direction: column;">
        <div v-if="isShowBackground" style="position: fixed; left: 0; top: 0; width: 100%; display: flex; justify-content: center; align-items: center; height: 100%; background-color: #00000080; z-index: 200;">
            <div style="font-weight: 700; font-size: 20px; color: #fff; height: 25px; overflow: hidden; text-align: center;">
                <div :style="{ transform: rollingFlag ? 'translateY(0px)' : 'translateY(-25px)' }" style="transition: transform 0.5s;">👏 사커하우에 오신 것을 환영합니다!</div>
                <div :style="{ transform: rollingFlag ? 'translateY(10px)' : 'translateY(-20px)' }" style="transition: transform 0.5s;">축구의 세계에 빠져들어보세요!</div>
            </div>
        </div>
        <div style="width: 1px; height: 1px; position: relative; top: 50%; left: 50%;">
            <div class="main_circle">
                <div style="margin-top: 2px;">
                    <img style="width: calc(0.18 * 100vw);" :src="require('@/assets/img/splash_logo.png')" alt="">
                </div>
                <div class="basic_circle_main second_circle"></div>
                <div class="basic_circle_main third_circle"></div>
                <div class="basic_circle_main fourth_circle"></div>
                <div class="basic_circle_item trophy_circle">
                    <img style="width: 50%;" :src="require('@/assets/img/splash_trophy.png')" alt="">
                </div>
                <div class="basic_circle_item goalpost_circle">
                    <img style="height: 70%;" :src="require('@/assets/img/splash_goalpost.png')" alt="">
                </div>
                <div class="basic_circle_item running_circle">
                    <img style="width: 50%;" :src="require('@/assets/img/splash_running.png')" alt="">
                </div>
                <div class="basic_circle_item fire_circle">
                    <img style="width: 50%;" :src="require('@/assets/img/splash_fire.png')" alt="">
                </div>
                <div class="basic_circle_item stadium_circle">
                    <img style="width: 65%;" :src="require('@/assets/img/splash_stadium.png')" alt="">
                </div>
                <div class="basic_circle_item cloth_circle">
                    <img style="width: 50%;" :src="require('@/assets/img/splash_cloth.png')" alt="">
                </div>
                <div class="basic_circle_item calendar_circle">
                    <img style="width: 64%;" :src="require('@/assets/img/splash_calendar.png')" alt="">
                </div>
            </div>
            <div :style="{ opacity: isLoaded ? '1' : '0' }" style="top: calc(0.52 * 100vw); border: none; border-radius: 0; z-index: 15; opacity: 0; transition: all 0.4s;transform: translate3d(-50%,-50%,0)" class="basic_circle_main">
                <div style="text-align: center;">
                    <div style="transition: all 0.7s;" :style="{ transform: isLoaded ? 'translateY(0)' : 'translateY(30px)' }">
                        <div style="">
                            <img style="width: 135px;" :src="require('@/assets/img/soccerhow_text.png')" alt="">
                        </div>
                        <div style="font-weight: 500;line-height: 24px;">내가 알던 축구의 확장</div>
                    </div>
                    <div @click="showSignupPopup" style="width: 316px; height: 72px; line-height: 72px; color: #fff; border-radius: 50px; background-color: #210f03; font-weight: 700; font-size: 14px; text-align: center; margin-top: 20px;">시작하기</div>
                    <div @click="showLoginPopup" style="font-weight: 500;line-height: 24px; margin-top: 20px;">이미 계정이 있나요? <span style="color: var(--color-main);">로그인하기</span></div>
                    <div style="font-size: 10px;font-weight: 400; margin-top: 40px; line-height: 24px; color: #606060;">로그인 및 가입 시 사커하우의 <span @click="showPrivacyPolity" style="color: var(--color-main);">이용약관, 개인정보 보호 정책</span>에 동의하게 됩니다.</div>
                </div>
            </div>
        </div>
        <StartLoginPopup style="z-index: 15" :showLoginPopup="showLoginPopup" :changeType="showSignupPopup" :completeAction="setIsShowBackground" :isOpen="isShowPopup" :closeCompleteAction="closePopup" :type="type" :changeHeight="modalHeight" :changeBottom="0" />
    </div>
</template>

<script>
import StartLoginPopup from "@/components/common/StartLoginPopup";

const MODAL_TYPE = {
    LOGIN: "LOGIN",
    START: "START",
    START_PC: "START_PC"
}

export default {
    name: 'LoginIntro',
    components: { StartLoginPopup },
    data() {
        return {
            isShowPopup: false,
            MODAL_TYPE: MODAL_TYPE,
            modalHeight: 0,
            type: MODAL_TYPE.START,
            device: '',
            rollingFlag: true,
            isShowBackground: false,
            isLoaded: false,
            test: false
        }
    },
    methods: {
        async setIsShowBackground(isSoccerhowWritten, loginInfo) {
            this.isShowBackground = true
            setTimeout(() => {
                this.rollingFlag = false
            }, 500);

            setTimeout(() => {
                this.isShowBackground = false
                this.rollingFlag = true;
                this.isShowPopup = false;
            }, 2000);

            setTimeout(async () => {
                let isOpenChatWritten

                this.$GlobalStore.closeLastModal(true);
                this.$router.push({ path: '/view/home' + '?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
                isOpenChatWritten = await this.$Axios.get('/api/chat/check/opentalk/contents/exist')
                await this.$Util.checkAfterLogin(isSoccerhowWritten, loginInfo, isOpenChatWritten.data.is_opentalk_written)
            }, 2500)

        },
        closePopup() {
            this.isShowPopup = false
        },
        showSignupPopup() {
            if (this.device === 'pc') {
                this.modalHeight = 426
                this.type = MODAL_TYPE.START_PC
            } else {
                this.modalHeight = 322
                this.type = MODAL_TYPE.START
            }
            this.isShowPopup = true
        },
        showLoginPopup() {
            this.type = MODAL_TYPE.LOGIN
            this.modalHeight = 470
            this.isShowPopup = true
        },
        showPrivacyPolity() {
            this.$GlobalStore.setIsShowPrivacyPolicy()
        }

    },
    mounted(){
        if(this.$hasOwnProperty(window, 'is_from_position_web') && window.is_from_position_web === true){
            this.showSignupPopup();
        }
    },
    created() {
        const device = this.$cookies.get('device');
        this.device = device

        setTimeout(() => {
            this.isLoaded = true
        }, 1000)
    }
}
</script>

<style scoped>
.basic_circle_main {
    position: absolute;
    border-radius: 50%;
    border: 1px solid #fff;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
}

.main_circle {
    position: absolute;
    width: calc(0.35 * 100vw);
    height: calc(0.35 * 100vw);
    border-radius: 50%;
    background: #FFFFFF66;
    border: 1px solid #fff;
    top: calc(-0.3 * 100vw);
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5;
}

.second_circle {
    width: calc(0.55 * 100vw);
    height: calc(0.55 * 100vw);
}

.third_circle {
    width: calc(0.80 * 100vw);
    height: calc(0.80 * 100vw);
}

.fourth_circle {
    width: calc(1.10 * 100vw);
    height: calc(1.10 * 100vw);
}

.basic_circle_item {
    position: absolute;
    border-radius: 50%;
    border: 1px solid #fff;
    transform: translate(-50%, -50%);
    backdrop-filter: blur(5px);
    background: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
}

.trophy_circle {
    width: calc(0.2 * 100vw);
    height: calc(0.2 * 100vw);
    top: calc(50% + -0.16 * 100vw);
    left: calc(50% + (0.32 * 100vw));
}

.goalpost_circle {
    width: calc(0.19 * 100vw);
    height: calc(0.19 * 100vw);
    top: calc(50% + 0.26 * 100vw);
    left: calc(50% + (0.22 * 100vw));
}

.running_circle {
    width: calc(0.16 * 100vw);
    height: calc(0.16 * 100vw);
    top: calc(50% + 0.26 * 100vw);
    left: calc(50% + (-0.20 * 100vw));
}

.running_circle {
    width: calc(0.16 * 100vw);
    height: calc(0.16 * 100vw);
    top: calc(50% + 0.26 * 100vw);
    left: calc(50% + (-0.20 * 100vw));
}

.fire_circle {
    width: calc(0.1 * 100vw);
    height: calc(0.1 * 100vw);
    top: calc(50% + 0.15 * 100vw);
    left: calc(50% + (-0.40 * 100vw));
}

.stadium_circle {
    width: calc(0.2 * 100vw);
    height: calc(0.2 * 100vw);
    top: calc(50% + -0.115 * 100vw);
    left: calc(50% + (-0.35 * 100vw));
}

.cloth_circle {
    width: calc(0.16 * 100vw);
    height: calc(0.16 * 100vw);
    top: calc(50% + -0.4 * 100vw);
    left: calc(50% + (-0.16 * 100vw));
}

.calendar_circle {
    width: calc(0.16 * 100vw);
    height: calc(0.16 * 100vw);
    top: calc(50% + -0.4 * 100vw);
    left: calc(50% + (0.14 * 100vw));
}
</style>